import { translatableZodSchema } from "@@/shared/translations/translation";
import { z } from "zod";

const templateSpecificationZodObject = z.object({
    title: translatableZodSchema,
    description: translatableZodSchema,
    items: z
        .array(
            z.object({
                iconName: z.string(),
                text: translatableZodSchema,
            }),
        )
        .min(1),
});

type TemplateSpecification = z.infer<typeof templateSpecificationZodObject>;

export { templateSpecificationZodObject };
export type { TemplateSpecification };
